"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fetchClient_1 = tslib_1.__importDefault(require("../fetchClient/fetchClient"));
const getSession = async ({ authProxyUrl, additionalHeaders }) => {
    var _a;
    let data = null;
    try {
        // first check if user is authenticated
        const statusResp = (await (0, fetchClient_1.default)(`${authProxyUrl}/authentication/status`, {
            headers: Object.assign({ 't-credentials': 1 }, additionalHeaders),
            withCredentials: true
        }));
        // if user is authed then fetch session data
        if ((_a = statusResp === null || statusResp === void 0 ? void 0 : statusResp.data) === null || _a === void 0 ? void 0 : _a.isValid) {
            const sessionResponse = (await (0, fetchClient_1.default)(`${authProxyUrl}/api/session`, {
                headers: Object.assign({ 't-credentials': 1, 't-target': 'session' }, additionalHeaders),
                withCredentials: true
            }));
            data = sessionResponse.data;
        }
    }
    catch (_b) {
        // fail silently, error dealt with in fetchClient
    }
    return data;
};
exports.default = getSession;
//# sourceMappingURL=getSession.js.map